import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  empanelmentEmailOTPValidation,
  empanelmentFetchDocument,
  empanelmentLogin,
  empanelmentNewRegister,
  empanelmentOptions,
  empanelmentOTPValidation,
  empanelmentPersonalDetails,
  empanelmentProfessionalDetails,
  empanelmentProfessionalRegistration,
  empanelmentRegister,
  empanelmentRegisterDetails,
} from "../../../api/empanelmentRegister_api";
import { setNewRegisterCookies } from "../../../helpers/auth";
// import { setNewRegisterCookies } from "../../../helpers/auth";

export const empanelmentOTPValidationAction = createAsyncThunk(
  "empanelment/OTPValidationAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await empanelmentOTPValidation(values);

      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const empanelmentRegisterAction = createAsyncThunk(
  "empanelment/RegisterAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await empanelmentRegister(values);

      const user = result.data;
      setNewRegisterCookies(user);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);
export const empanelmentEmailOTPValidationAction = createAsyncThunk(
  "empanelment/emailOTPValidation",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await empanelmentEmailOTPValidation(values);

      const user = result.data;
      setNewRegisterCookies(user);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const empanelmentLoginAction = createAsyncThunk(
  "empanelment/LoginAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await empanelmentLogin(values);
      const user = result?.data;

      setNewRegisterCookies(user);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const empanelmentOptionsAction = createAsyncThunk(
  "empanelment/optionsAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await empanelmentOptions();

      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const empanelmentProfessionalRegistrationAction = createAsyncThunk(
  "empanelment/professionalRegistrationAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await empanelmentProfessionalRegistration(values);

      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const empanelmentPersonalDetailsAction = createAsyncThunk(
  "empanelment/personalDetailsAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await empanelmentPersonalDetails(values);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const empanelmentRegisterDetailsAction = createAsyncThunk(
  "empanelment/registerDetailsAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await empanelmentRegisterDetails(values);

      return result?.data?.data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const empanelmentFetchDocumentAction = createAsyncThunk(
  "empanelment/fetchDocumentAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await empanelmentFetchDocument(values);

      return result?.data?.data ?? [];
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);



export const empanelmentProfessionalDetailsAction = createAsyncThunk(
  "empanelment/professionalDetails",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await empanelmentProfessionalDetails(values);

      return result?.data?.data ?? [];
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);
